import styled from "styled-components";
import { Dialog, DialogContent } from "@material-ui/core";
import { cuideoTheme } from "../../../../containers/themes/defaultTheme";

// Reduce el margen por defecto del diálogo (32px) respecto al borde de pantalla.
export const StyledDialog = styled(Dialog)`
  & .MuiDialog-paper {
    margin: 0.75rem;
  }
  & .MuiDialog-paperFullWidth {
    width: calc(100% - 1.5rem);
  }
`;

export const ModalContent = styled(DialogContent)`
  min-height: 18rem;
  padding-bottom: 1.5rem;
`;

export const ModalDayLabel = styled.div`
  font-family: "Source Sans Pro", Helvetica, Arial, sans-serif;
  font-size: 0.95rem;
  font-weight: 600;
  color: ${cuideoTheme.palette.primary.main};
  margin-bottom: 1rem;
`;

export const ModalRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-around;
  gap: 1rem;
`;

export const ModalErrorWrapper = styled.div`
  margin-top: 1rem;
`;
